import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-273.78 -348.44 1955.56 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1408 800V608Q1408 568 1380.0 540.0Q1352 512 1312 512H896V96Q896 56 868.0 28.0Q840 0 800 0H608Q568 0 540.0 28.0Q512 56 512 96V512H96Q56 512 28.0 540.0Q0 568 0 608V800Q0 840 28.0 868.0Q56 896 96 896H512V1312Q512 1352 540.0 1380.0Q568 1408 608 1408H800Q840 1408 868.0 1380.0Q896 1352 896 1312V896H1312Q1352 896 1380.0 868.0Q1408 840 1408 800Z"
	})
});
export default SvgAdd;
